// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21ZRz","newExpiryDate":"styles_newExpiryDate__3v2Zh","footer":"styles_footer__l0lF-"};